// removed by extract-text-webpack-plugin
module.exports = {"EkycForeignInvestor":"EkycForeignInvestor","ForeignText":"ForeignText","PhotoPicker":"PhotoPicker","InputContainer":"InputContainer","Note":"Note","WarningNote":"WarningNote","CustomFileInput":"CustomFileInput"};


//////////////////
// WEBPACK FOOTER
// ./src/screens/KisEkyc/Step3/ForeignInvestor/style.scss
// module id = 2309
// module chunks = 10